"use strict";
/**
 * Created on 02 09 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ObjectUtils_1 = require("../../core/utils/ObjectUtils");
/**
 * Representation of key to compute {@link PromotionProduct.sites}.
 * <br/>
 * You can use this tuple as a key of immutable map or as a value of immutable set.
 * @author JMe
 */


var PromotionProductSitesInputKey =
/*#__PURE__*/
function () {
  /**
   * @param groupOfSitesId Refers to {@link PromotionProduct.groupOfSitesId}.
   * @param validFrom Refers to {@link PromotionProduct.validFrom}.
   * @param validTo Refers to {@param PromotionProduct.validTo}.
   * @param parentGroupOfSitesId Refers to {@param PromotionProduct.parentGroupOfSitesId}.
   * @param parentValidFrom Refers to {@param PromotionProduct.parentValidFrom}.
   * @param parentValidTo Refers to {@param PromotionProduct.parentValidTo}.
   */
  function PromotionProductSitesInputKey(groupOfSitesId, validFrom, validTo, parentGroupOfSitesId, parentValidFrom, parentValidTo) {
    _classCallCheck(this, PromotionProductSitesInputKey);

    this.groupOfSitesId = groupOfSitesId;
    this.validFrom = validFrom;
    this.validTo = validTo;
    this.parentGroupOfSitesId = parentGroupOfSitesId;
    this.parentValidFrom = parentValidFrom;
    this.parentValidTo = parentValidTo;
  }

  _createClass(PromotionProductSitesInputKey, [{
    key: "equals",
    value: function equals(other) {
      if (other instanceof PromotionProductSitesInputKey) {
        var otherKey = other;
        return this.groupOfSitesId === otherKey.groupOfSitesId && this.validFrom.valueOf() === otherKey.validFrom.valueOf() && this.validTo.valueOf() === otherKey.validTo.valueOf() && this.parentGroupOfSitesId === otherKey.parentGroupOfSitesId && this.parentValidFrom.valueOf() === otherKey.parentValidFrom.valueOf() && this.parentValidTo.valueOf() === otherKey.parentValidTo.valueOf();
      } else {
        return false;
      }
    }
  }, {
    key: "hashCode",
    value: function hashCode() {
      return ObjectUtils_1.ObjectUtils.hashCode("".concat(this.groupOfSitesId, "_").concat(this.validFrom.valueOf(), "_").concat(this.validTo.valueOf(), "_").concat(this.parentGroupOfSitesId, "_").concat(this.parentValidFrom.valueOf(), "_").concat(this.parentValidTo.valueOf()));
    }
  }, {
    key: "toString",
    value: function toString() {
      return "groupOfSitesId=".concat(this.groupOfSitesId, ", validFrom=").concat(this.validFrom, ", validTo=").concat(this.validTo, ", parentGroupOfSitesId=").concat(this.parentGroupOfSitesId, ", parentValidFrom=").concat(this.parentValidFrom, ", parentValidTo=").concat(this.parentValidTo);
    }
  }]);

  return PromotionProductSitesInputKey;
}();

exports.PromotionProductSitesInputKey = PromotionProductSitesInputKey;